import React from "react";
import { colorSchemes } from "../assets/commonFunction";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
const ArkchatDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialogActions-root": {
    padding: 0,
  },
}));
const classes = {
  iconn: {
    color: colorSchemes.crossIconBorder,
  },
  radioStyle: {
    color: "#092C4C",
    padding: "0.25rem",
    "&.Mui-checked": {
      color: "#092C4C",
    },
  },
};
function ArkchatDialogTitle(props) {
  const { children, onClose, classes, ...other } = props;

  return (
    <DialogTitle
      sx={{ m: 0, p: "0.5rem 0rem", display: "flex", alignItems: "center" }}
      {...other}
    >
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            height: "30px",
            width: "30px",
            borderRadius: "2px",
            margin: "0 10px",
            background: colorSchemes.transparent,
            border: `1px solid ${colorSchemes.crossIconBorder}`,
            "&:hover": {
              background: colorSchemes.transparent,
              border: `1px solid ${colorSchemes.crossIconBorder}`,
            },
          }}
        >
          <CloseIcon sx={classes?.iconn} />
        </IconButton>
      ) : null}
      <Typography variant="subtitle2">{children}</Typography>
    </DialogTitle>
  );
}
export default function CustomPopup({
  handleCloseAction,
  open,
  title,
  handleClose,
  children,
  footer
}) {
  return (
    <div>
      <ArkchatDialog
        sx={{ border: "1px solid" }}
        onClose={handleCloseAction}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="xs"
        onBac
      >
        <ArkchatDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          classes={classes}
        >
          {title}
        </ArkchatDialogTitle>
        <DialogContent sx={{justifyContent:'center'}}>
          {children}
        </DialogContent>
        <DialogActions sx={{m:0,justifyContent:'center'}}>
          {footer}
        </DialogActions>
      </ArkchatDialog>
    </div>
  );
}
